import "../../../assets/scss/google-cloud-download-modal-style.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, Spin } from "antd";
import {
  BranchesOutlined,
  DesktopOutlined,
  LoadingOutlined,
  RobotOutlined,
} from "@ant-design/icons";

import { getDockerFileList } from "../../server/GoogleDrive";
import { getInstances } from "../../server/Instances";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { InstanceCardInterface } from "../../utility/interface/instance-card";
import {
  updateDockerList,
  updatedSelectedDocker,
} from "../../features/cloud/cloudSlice";

const InstanceSelectModal = (props: any) => {
  const { t } = useTranslation();
  const { modalState, switchtoDockerListFn, onCancelfn } = props;
  const userState = useAppSelector((state: any) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [instancesList, setInstancesList] = useState<InstanceCardInterface[]>(
    []
  );

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const fetchInstanceList = async () => {
    try {
      const response = await getInstances();
      const data = await response.data;
      setLoading(false);
      if (data.instances !== null) {
        setInstancesList(data.instances.reverse());
      }
    } catch {
      setInstancesList([]);
    }
  };

  const getDockerFiles = async (instance_id: string, host_id: string) => {
    setLoading(true);
    getDockerFileList({
      command: 1,
      new_file_name: "",
      search_keyword: "",
      file: "",
      instance_id: instance_id,
      host_id: host_id,
      user_id: userState.user_id,
    })
      .then((res) => {
        dispatch(updateDockerList(res.data.ops_result));
        dispatch(
          updatedSelectedDocker({
            user_id: userState.user_id,
            instance_id: instance_id,
            host_id: host_id,
          })
        );
        setLoading(false);
        onCancelfn();
        switchtoDockerListFn();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (userState.user_id) {
      setLoading(true);
      fetchInstanceList();
    }
  }, [useState]);

  return (
    <Modal
      open={modalState}
      onCancel={() => onCancelfn()}
      width={"auto"}
      className="google-cloud-download-modal"
      footer={null}
      closable={!loading}
      centered
    >
      {instancesList.length === 0 && loading == false && (
        <div className="no-instances">
          <p>{t("No Machines Yet")}</p>
          <Button onClick={() => navigate("/")}>{t("Go to Rental")}</Button>
        </div>
      )}
      {loading === true ? (
        <div
          style={{
            display: "flex",
            alignItems: "middle",
            justifyContent: "center",
          }}
        >
          <Spin indicator={<LoadingOutlined spin style={{ fontSize: 72 }} />} />
        </div>
      ) : (
        <div className="file-cloud-download">
          {instancesList.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="instance-item"
                onClick={() => {
                  getDockerFiles(item.instance_id, item.host_id);
                }}
              >
                {item.host_id}
                <li>
                  <DesktopOutlined /> ID: {item.instance_id}
                </li>
                <li>
                  <RobotOutlined /> {t("Machine")}: {item.product_name}
                </li>
                <li>
                  <BranchesOutlined /> {t("GPU Count")}: {item.gpu_available}{" "}
                  GPU
                </li>
                <strong>{t("Choose This Instance")}</strong>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default InstanceSelectModal;
